import { useEffect, useState } from "react";
import { Clock, MapPin, Navigation } from "lucide-react";
import { api } from "@/lib/api";

export const Location = () => {
  const [s, setS] = useState(null);
  const [outlets, setOutlets] = useState([]);
  const [oc, setOc] = useState("");

  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => setS({}));
    api.get("/outlets").then((r) => { setOutlets(r.data); setOc(r.data[0]?.code || ""); }).catch(() => {});
  }, []);

  const o = outlets.find((x) => x.code === oc) || {};
  const address = o.address?.trim();
  const coords = o.coords?.replace(/\s+/g, "");
  const q = encodeURIComponent(coords || (address ? `UPLINK COFFEE, ${address}` : ""));
  const hasLoc = Boolean(coords || address);

  return (
    <section id="lokasi" className="wrap mt-20 sm:mt-28 scroll-mt-24" data-testid="location-section">
      <span className="text-xs font-bold tracking-[0.15em] text-forest">KUNJUNGI KAMI</span>
      <h2 className="font-serif font-semibold text-3xl sm:text-4xl tracking-tight text-ink mt-2">Mampir kapan saja.</h2>
      {outlets.length > 1 && (
        <div className="flex flex-wrap gap-2 mt-4">
          {outlets.map((x) => (
            <button key={x.code} onClick={() => setOc(x.code)} data-testid={`location-outlet-${x.code}`}
              className={`pill ${oc === x.code ? "bg-forest text-paper" : "bg-sage-100 hover:bg-sage-200"}`}>Gerai {x.name}</button>
          ))}
        </div>
      )}
      <div className="grid lg:grid-cols-[240px_1fr] gap-4 mt-8">
        <div className="grid grid-cols-2 lg:grid-cols-1 gap-3 content-start">
          <div className="bg-forest text-paper rounded-xl p-4 relative overflow-hidden" data-testid="location-hours">
            <Clock className="w-4 h-4 text-amber-200" strokeWidth={1.8} />
            <div className="font-serif font-semibold text-2xl mt-2">24 Jam</div>
            <div className="text-xs opacity-85 mt-0.5">{s?.hours || "Buka 24 jam, setiap hari"}</div>
          </div>
          <div className="card-paper rounded-xl p-4" data-testid="location-address">
            <MapPin className="w-4 h-4 text-forest" strokeWidth={1.8} />
            <div className="font-semibold text-sm mt-2">Alamat{o.name ? ` · Gerai ${o.name}` : ""}</div>
            <p className="text-xs text-ink/80 mt-0.5 whitespace-pre-line">{address || "[Alamat belum diisi]"}</p>
            {hasLoc && (
              <a href={`https://www.google.com/maps/search/?api=1&query=${q}`} target="_blank" rel="noopener noreferrer"
                className="btn-forest inline-flex items-center gap-1.5 px-3 py-1.5 mt-3 text-xs rounded-lg" data-testid="location-directions-link">
                <Navigation className="w-3 h-3" /> Petunjuk arah
              </a>
            )}
          </div>
        </div>
        <div className="rounded-xl overflow-hidden border border-sage-200 bg-sage-100 h-[220px] lg:h-auto lg:min-h-[200px]" data-testid="location-map">
          {hasLoc ? (
            <iframe title="Peta UPLINK COFFEE" src={`https://www.google.com/maps?q=${q}&z=17&output=embed`} className="w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          ) : (
            <div className="h-full grid place-items-center text-center p-8 text-muted2 text-sm">Peta akan tampil setelah alamat diisi.</div>
          )}
        </div>
      </div>
    </section>
  );
};
